'use client';

import type { ArticleHeading } from '@/lib/blog-content';

type BlogTableOfContentsProps = {
  headings: ArticleHeading[];
  label: string;
};

export function BlogTableOfContents({ headings, label }: BlogTableOfContentsProps) {
  const sections = headings.filter((heading) => heading.level === 2);
  if (sections.length < 3) return null;

  return (
    <nav
      aria-label={label}
      className="not-prose mb-6 rounded-xl border border-white/10 bg-white/[0.02] p-4 md:p-5"
    >
      <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-slate-500">{label}</p>
      <ol className="space-y-2 text-sm">
        {sections.map((heading) => (
          <li key={heading.id}>
            <a
              href={`#${heading.id}`}
              className="text-slate-300 transition-colors hover:text-[#ffb74d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ffb74d]/50"
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
